import React from 'react'

export const YesNoPill: React.FC<{
  value: boolean
  trueLabel?: string
  falseLabel?: string
}> = ({ value, trueLabel = 'Yes', falseLabel = 'No' }) => {
  return (
    <span
      className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-semibold ${
        value ? 'bg-green-700 text-white' : 'bg-red-600 text-white'
      }`}
    >
      {value ? trueLabel : falseLabel}
    </span>
  )
}
